import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { cardsService } from "./cardsService";

export const updatePIN = async (
  cardId: string,
  request: cardApiSpec.SetPinRequest
): Promise<cardApiSpec.Card> => {
  const { data } = await cardsService.post(`/${cardId}/set_pin`, request);

  return data;
};
